import React from 'react';
import { UserPenIcons } from '../../../../icons/icons';
import { DataTable } from '../../../../ui';
import { Button } from '../../../../ui/components/Common/Buttons/Button';
import {
  ContextMenu,
  MenuItemType,
} from '../../../../ui/components/Common/ContextMenu/ContextMenu';
import { PencilIcon, TrashIcon } from '../../../../ui/icons/icons';
import { OrgUser, getUserColumns } from './Functions/GetColumns';

const USERS_DATA: OrgUser[] = [
  {
    id: 1,
    name: 'Jane Doe',
    email: 'jane.doe@acmeglobal.com',
    role: 'Owner',
    status: 'Active',
    joined: 'June 2021',
  },
  {
    id: 2,
    name: 'John Smith',
    email: 'john.smith@acmeglobal.com',
    role: 'Admin',
    status: 'Active',
    joined: 'July 2021',
  },
  {
    id: 3,
    name: 'Sarah Jenkins',
    email: 'sarah.j@acmeglobal.com',
    role: 'Admin',
    status: 'Active',
    joined: 'August 2021',
  },
  {
    id: 4,
    name: 'Michael Chen',
    email: 'm.chen@acmeglobal.com',
    role: 'Member',
    status: 'Inactive',
    joined: 'January 2022',
  },
];

const UsersTab = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [selectedUser, setSelectedUser] = React.useState<OrgUser | null>(null);

  const handleOpenMenu = (
    e: React.MouseEvent<HTMLButtonElement>,
    row: unknown,
  ) => {
    setAnchorEl(e.currentTarget);
    setSelectedUser(row as OrgUser);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedUser(null);
  };

  const handleEdit = (user: OrgUser) => {
    console.log('Editing user:', user);
    handleCloseMenu();
  };

  const handleDelete = (user: OrgUser) => {
    console.log('Deleting user:', user);
    handleCloseMenu();
  };

  const menuItems: MenuItemType<OrgUser>[] = [
    {
      label: 'Update',
      icon: <PencilIcon className='w-4 h-4' />,
      permission: [],
      onClick: (row) => handleEdit(row),
    },
    {
      label: 'Delete Item',
      icon: <TrashIcon className='w-4 h-4 text-rose-500' />,
      permission: [],
      onClick: (row) => handleDelete(row),
    },
  ];

  const columns = getUserColumns(
    handleOpenMenu,
    handleCloseMenu,
    anchorEl,
    selectedUser,
  );

  return (
    <div className='space-y-8'>
      <div className='flex justify-between items-center mb-4'>
        <div>
          <h1 className='text-3xl font-black text-slate-800 tracking-tighter'>
            Organization Users
          </h1>
          <p className='text-slate-500 font-medium'>
            Manage and invite team members to this organization.
          </p>
        </div>
        <Button
            label='Invite User'
            variant='primary'
            className='rounded-xl px-6 py-2.5 font-bold shadow-lg shadow-emerald-200/50'
        />
      </div>

      <div className='bg-white border border-slate-100 shadow-sm overflow-hidden'>
        <DataTable
            columns={columns}
            data={USERS_DATA}
            rowsPerPage={10}
            totalRecords={USERS_DATA.length}
            totalPages={1}
            currentPage={1}
            onPageChange={() => {}}
        />
      </div>
      { anchorEl && selectedUser && (
        <ContextMenu
            anchorEl={anchorEl}
            onClose={handleCloseMenu}
            row={selectedUser}
            menuItems={menuItems}
        />
      ) }
    </div>
  );
};

export default UsersTab;
